import {
  isActionVisibleOnDashboard,
  isActionCompleted,
  isActionDisabledByDate,
  isOrgAdminAction,
  type Action,
} from "@core/features/actions";
import { ActionListCard } from "@themes/pollinator/ui/ActionListCard";
import { ProgramPhaseActionItemContainer } from "./ProgramPhaseActionItemContainer";
import { ProgramPhaseActionItemPlaceholder } from "./ProgramPhaseActionItemPlaceholder";

type Props = {
  actions: Action[];
  isLoading: boolean;
};

export function ProgramPhaseActionList({ actions, isLoading }: Props) {
  // Filter to visible actions, excluding org admin actions (shown in separate section)
  const visibleActions = actions?.filter(
    (action) => isActionVisibleOnDashboard(action) && !isOrgAdminAction(action),
  );
  const completedCount = visibleActions?.filter(isActionCompleted).length ?? 0;
  const totalCount = visibleActions?.length ?? 0;

  return (
    <ActionListCard
      title="Actions"
      completedCount={completedCount}
      totalCount={totalCount}
      isLoading={isLoading}
      emptyMessage="No actions required at this time."
      className="h-full"
      loadingContent={
        <>
          {Array.from({ length: 3 }).map((_, index) => (
            <ProgramPhaseActionItemPlaceholder key={index} />
          ))}
        </>
      }
    >
      {visibleActions?.map((action, idx) => (
        <ProgramPhaseActionItemContainer
          key={`${action.name}-${idx}`}
          disabled={isActionDisabledByDate(action)}
          action={action}
        />
      ))}
    </ActionListCard>
  );
}

export default ProgramPhaseActionList;
